import { render, staticRenderFns } from "./Asistentes.vue?vue&type=template&id=55773c23&"
import script from "./Asistentes.vue?vue&type=script&lang=js&"
export * from "./Asistentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports